import React from 'react';

import { SidebarModalSectionComponent } from 'design/sidebarModal';
import {
  SidebarModalNavigationControlComponent,
  SidebarModalNavigationLayoutComponent,
} from 'design/sidebarModalNavigation';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TextComponent } from 'design/text/textComponents';
import { PartnerManagerData, PartnerManagerScreen } from 'types/partnerManager';

type Props = {
  currentScreen: PartnerManagerScreen;
  parnerManagerData: PartnerManagerData;
  onViewSummary(): void;
  onViewFinances(): void;
  onViewClients(): void;
};

export const PartnerManagerHeader = (props: Props) => {
  const {
    currentScreen,
    parnerManagerData,
    onViewSummary: viewSummary,
    onViewFinances: viewFinances,
    onViewClients: viewClients,
  } = props;

  const {
    shared: sharedDitctionary,
    partnerManager: { tabs: tabsDictionary },
  } = useIntlDictionary();

  const { partner } = parnerManagerData;

  const { profile: partnerProfile } = partner;

  const partnerFullName = sharedDitctionary.partnerFullName(partnerProfile);

  return (
    <SidebarModalSectionComponent
      theme="head"
      content={
        <TextComponent size="mpp" weight="medium">
          {partnerFullName}
        </TextComponent>
      }
      actions={null}
      navigation={
        <SidebarModalNavigationLayoutComponent>
          <SidebarModalNavigationControlComponent
            onPress={viewSummary}
            active={currentScreen.name === 'SUMMARY'}
          >
            <TextComponent>{tabsDictionary.summaryTabText}</TextComponent>
          </SidebarModalNavigationControlComponent>
          <SidebarModalNavigationControlComponent
            onPress={viewFinances}
            active={currentScreen.name === 'FINANCES'}
          >
            <TextComponent>{tabsDictionary.financesTabText}</TextComponent>
          </SidebarModalNavigationControlComponent>
          <SidebarModalNavigationControlComponent
            onPress={viewClients}
            active={currentScreen.name === 'CLIENTS'}
          >
            <TextComponent>{tabsDictionary.clientsTabText}</TextComponent>
          </SidebarModalNavigationControlComponent>
        </SidebarModalNavigationLayoutComponent>
      }
    />
  );
};
